import { ENV } from "../utils";

export class GeiFactorLibrary {
  baseApi = ENV.BASE_API;

  async getRevisionCalendar(accessToken) {
    const response = await fetch(`${this.baseApi}/gei-revision-calendar`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createRevisionEntry(accessToken, data) {
    const response = await fetch(`${this.baseApi}/gei-revision-calendar`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 201) throw result;
    return result;
  }

  async updateRevisionEntry(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/gei-revision-calendar/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteRevisionEntry(accessToken, id) {
    const response = await fetch(`${this.baseApi}/gei-revision-calendar/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getCombustionFactors(accessToken) {
    const response = await fetch(`${this.baseApi}/gei-factor-library/combustion`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async getElectricityFactors(accessToken) {
    const response = await fetch(`${this.baseApi}/gei-factor-library/electricity`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
